import { render, staticRenderFns } from "./AttachementZone.vue?vue&type=template&id=af6614d8&scoped=true&"
import script from "./AttachementZone.vue?vue&type=script&lang=ts&"
export * from "./AttachementZone.vue?vue&type=script&lang=ts&"
import style0 from "./AttachementZone.vue?vue&type=style&index=0&id=af6614d8&scoped=true&lang=css&"
import style1 from "./AttachementZone.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6614d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af6614d8')) {
      api.createRecord('af6614d8', component.options)
    } else {
      api.reload('af6614d8', component.options)
    }
    module.hot.accept("./AttachementZone.vue?vue&type=template&id=af6614d8&scoped=true&", function () {
      api.rerender('af6614d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/incidents/shared/components/AttachementZone.vue"
export default component.exports